import React, { Component } from "react";
import styled from "styled-components";
import { StyledBaseTable, StyledLabelString } from './styledBaseTable';
import { LabelDate, LabelDollarFormatted, LabelString } from '@loanbossinc/component-library';
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { getEnvConfig } from "helpers/environment-config";
import { convertIntegerToGUID } from "helpers/guid";

const StyledLenderCell = styled.div`
  && {
    display: flex;
    flex-direction: column;
    border: none;  
  }
`;

const convertDealIdToGuid = (value) => {
  if (!isNaN(Number(value)) && Number.isInteger(Number(value))) {
    return convertIntegerToGUID(Number(value));
  }
  return value;
};

class TerminatedHedgeTable extends Component {
  columns = [
    {
      id: 'provider'
      , label: 'HEDGE PROVIDER'
      , path: 'provider'
      , Cell: (value) => (
        <StyledLenderCell>
          <StyledLabelString value={value.hedgeType} />
          {value.name && <LabelString value={value.name} />}
        </StyledLenderCell>
      )
    }
    , {
      id: 'terminationDate'
      , label: 'TERMINATION DATE'
      , path: 'terminationDate'
      , Cell: (value) => <LabelDate value={value} />
    }
    , {
      id: 'notionalAtTermination'
      , label: 'TERM NOTIONAL'
      , path: 'notionalAtTermination'
      , Cell: (value) => <LabelDollarFormatted value={value} />
    }
    , {
      id: 'terminationValue'
      , label: 'TERM VALUE'
      , path: 'terminationValue'
      , Cell: (value) => <LabelDollarFormatted value={value} />
    }
  ];

  mapData = () => {
    const { data } = this.props;

    return data.map(item => {

      return {
        ...item
        , provider: {
          hedgeType: item.hedgeType && item.hedgeType.value
          , name: item.hedgeProvider && item.hedgeProvider.name
        }
      };
    });
  }

  handleRowClick = async (hedge) => {
    const { history, flags, dealId } = this.props;

    if (flags.bar2105RedirectToNewHedgeViewPage) {
      const newFrontendUrl = await getEnvConfig("newFrontendUrl");
      const dealIdGuid = convertDealIdToGuid(dealId || hedge.dealId);
      window.location.assign(`${newFrontendUrl}/deals/${dealIdGuid}/hedges/${hedge.id}`);
    } else {
      history.push(`/hedges/${hedge.id}`);
    }
  };

  render() {
    const { data } = this.props;
    if (!data.length) return null;

    return (
      <StyledBaseTable
        columns={this.columns}
        onRowClick={this.handleRowClick}
        items={this.mapData()}
      />
    );
  }
}

const TerminatedHedgeTableWithFlags = withLDConsumer()(TerminatedHedgeTable);
export { TerminatedHedgeTableWithFlags as TerminatedHedgeTable };
export default TerminatedHedgeTableWithFlags;

